import { Heading } from '@lili/lili-frontend-common';
import { Icon, Icons } from '@Components/icon/Icon';

interface CurrentDateProps {
  label: string;
  className?: string;
}

export const CurrentDate = ({ label, className = '' }: CurrentDateProps) => {
  const formattedDate = new Date().toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  return (
    <Heading.H10 className={`flex flex-row gap-[8px] items-center ${className}`}>
      {label}
      <div className='bg-surface-primary-bw-02 px-[10px] py-[4px] rounded-[6px] outline outline-1 outline-surface-primary-bw-03 flex flex-row gap-[4px] items-center'>
        <Icon icon={Icons.Calendar} />
        <Heading.H9>{formattedDate}</Heading.H9>
      </div>
    </Heading.H10>
  );
};
